import { belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type { IntlService } from "ember-intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
import type CareGiverAddedJournalEvent from "./care-giver-added-journal-event";
//---- Automatically generated, don't update this part ----

export default class ReferentLabUpdatedJournalEvent extends JournalEvent {
  static override type = "referent-lab-updated-journal-event";

  @belongsTo("care-giver-added-journal-event", {
    async: false,
    inverse: "referentLabUpdatedJournalEvent"
  })
  declare careGiverAddedJournalEvent: CareGiverAddedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.referent-lab-updated-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "referentLabUpdatedJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "referent-lab-updated-journal-event": ReferentLabUpdatedJournalEvent;
  }
}
